export const HOT_GAME_BADGE = {
  HOT: 0,
  NEW: 1
}

export function isNewHotGame (game) {
  if (!game || game.category === undefined || game.category === null) return false
  return Number(game.category) === HOT_GAME_BADGE.NEW
}

export function getHotGameBadge (game) {
  return isNewHotGame(game) ? 'NEW' : 'HOT'
}

export const SLOT_CATEGORY = 1
export const LIVE_CATEGORY = 2
export const FISHING_CATEGORY = 3
export const MINI_GAME_CATEGORY = 4
export const SPORTS_CATEGORY = 5

export function resolveGameCategoryLabel (category, t) {
  const value = Number(category)
  if (value === LIVE_CATEGORY) return t('games.categoryLive')
  if (value === FISHING_CATEGORY) return t('games.categoryFishing')
  if (value === MINI_GAME_CATEGORY) return t('games.categoryMini')
  if (value === SPORTS_CATEGORY) return t('games.categorySports')
  if (value === SLOT_CATEGORY) return t('games.categorySlot')
  return t('games.categoryOther')
}

export function normalizeSlotGames (payload) {
  if (!payload) return []
  const list = Array.isArray(payload) ? payload : (payload.data || payload.list || [])
  if (!Array.isArray(list)) return []
  return list.map(item => ({
    provider: item.provider,
    provider_name: item.provider_name || item.providerName || '',
    code: item.code,
    name: item.name || item.code || '',
    image: item.image || '',
    category: item.category,
    vendor_id: item.vendor_id,
    is_hot: !!item.is_hot
  }))
}

export function normalizeFishingGames (payload) {
  return normalizeSlotGames(payload)
}

export function resolveFishingVendorId (game) {
  if (!game) return -1
  const vendorId = Number(game.vendor_id)
  return Number.isFinite(vendorId) ? vendorId : -1
}

export function normalizeHotGames (payload) {
  if (!payload) return []
  const list = Array.isArray(payload) ? payload : (payload.data || payload.list || [])
  if (!Array.isArray(list)) return []
  return list.map(item => ({
    provider_name: item.provider_name,
    provider: item.provider,
    providerLabel: item.provider_name || item.providerName || '',
    code: item.code,
    name: item.name || item.code || '',
    image: item.image || '',
    category: item.category,
    is_hot: !!item.is_hot
  }))
}
